import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { isEmpty, cloneDeep, sortBy } from 'lodash';
import moment from 'moment';
import PageTitle from '../../../../components/PageTitle';
import RouteNames from '../../../App/RouteNames';
import {
  uploadMultiPartFiles,
  saveOutputTemplateByType,
  getOutputTemplateByType,
  getConfigFailureCodesList,
  getConfigIdd,
  getConfigIdo,
  getConfigIncomingOutgoingRoute,
  getConfigSreserved,
  getConfigOrganization,
} from '../../../App/actions';
import TitleFrom from '../../../../components/common/TitleFrom';
import { RawNonBroadsoftSearchForm } from '../../../../components/ReportHub';
import {
  SwitchExport,
  DataTable,
  ExcelExport,
  TablePagination,
  ButtonExport,
  EmailGroup,
  DragDropConfigExportTemplate,
  ModalWithItem,
} from '../../../../components/common';
import { tabelColumnExportRawNonBroadsoft, sortRawNonBroadsoft } from '../../constants';
import { getNonBroadSoftRawCdrData, getAllNonBroadSoftRawCdrData, onResetDefaultData } from '../../actions';
import { makeGetListRawNonBroadsoft, makeGetListAllRawNonBroadsoft } from '../../selectors';
import {
  getPageTotalCount,
  parseToMutationRequestPostMethod,
  blobToFile,
  validateEmail,
  blobToCSVFile,
  configOutputTemplateByType,
} from '../../../../utils/utils';
import convertJson2Sheet from '../../../../utils/ExcelHelper/exportExcelFile';
import convertJson2Pdf from '../../../../utils/PdfHelper/exportPdfFile';
import { PAGE_SIZE_DOWNLOAD } from '../../../../utils/constants';

let tableColumnsOutput = null;
class RawNonBroadsoft extends Component {
  state = {
    isActivePdf: false,
    page: 0,
    size: 20,
    filter: {},
    sort: '',
    sorted: {},
    totalCount: null,
    isSearching: false,
    listRawNonBroadsoft: [],
    failureCodesOption: [],
    iddOption: [],
    idoOption: [],
    incomingOutgoingRouteOption: [],
    sreservedOption: [],
    configOrganizationOption: [],
  };

  buttonRef = React.createRef();

  static getDerivedStateFromProps(props, state) {
    moment()
      .endOf('month')
      .format('YYYY-MM-DD');
    return {
      listRawNonBroadsoft: props.listRawNonBroadsoft,
      totalCount: getPageTotalCount({ ...state, items: props.listRawNonBroadsoft }),
    };
  }

  componentDidMount() {
    const {
      permissions: { modeGetNonBroadsoftMapReport },
      onResetDefaultData,
      getConfigFailureCodesList,
      getConfigIdd,
      getConfigIdo,
      getConfigIncomingOutgoingRoute,
      getConfigSreserved,
      getConfigOrganization,
    } = this.props;
    if (modeGetNonBroadsoftMapReport) {
      this.doGetOutputTemplateByType();
      onResetDefaultData('listNonBroadsoft');
      // getConfigFailureCodesList('', ({ success, data }) => {
      //   if (success) {
      //     let failureCodesOption = [];
      //     if (data && data.configFailureCodesList && data.configFailureCodesList.length) {
      //       failureCodesOption = data.configFailureCodesList.map(val => {
      //         return { label: val.value, value: val.value };
      //       });
      //     }
      //     this.setState({
      //       failureCodesOption:
      //         failureCodesOption && failureCodesOption.length ? sortBy(failureCodesOption, ['label']) : [],
      //     });
      //   }
      // });
      this.doGetConfigFailureCodesList();

      getConfigOrganization('', ({ success, data }) => {
        if (success) {
          let configOrganizationOption = [];
          if (data && data.configOrganizationList && data.configOrganizationList.length) {
            configOrganizationOption = data.configOrganizationList.map(val => {
              return { label: val.value, value: val.value };
            });
          }
          this.setState({
            configOrganizationOption:
              configOrganizationOption && configOrganizationOption.length
                ? sortBy(configOrganizationOption, ['label'])
                : [],
          });
        }
      });

      getConfigIdd('', ({ success, data }) => {
        if (success) {
          let iddOption = [];
          if (data && data.configIddList && data.configIddList.length) {
            iddOption = data.configIddList.map(val => {
              return { label: val.value, value: val.value };
            });
          }
          this.setState({
            iddOption: iddOption && iddOption.length ? sortBy(iddOption, ['label']) : [],
          });
        }
      });
      getConfigIdo('', ({ success, data }) => {
        if (success) {
          let idoOption = [];
          if (data && data.configIdoList && data.configIdoList.length) {
            idoOption = data.configIdoList.map(val => {
              return { label: val.value, value: val.value };
            });
          }
          this.setState({ idoOption: idoOption && idoOption.length ? sortBy(idoOption, ['label']) : [] });
        }
      });
      getConfigSreserved('', ({ success, data }) => {
        if (success) {
          let sreservedOption = [];
          if (data && data.configSreservedList && data.configSreservedList.length) {
            sreservedOption = data.configSreservedList.map(val => {
              return { label: `${val.value}${val.description ? `: ${val.description}` : ''}`, value: val.value };
            });
          }
          this.setState({
            sreservedOption: sreservedOption && sreservedOption.length ? sortBy(sreservedOption, ['label']) : [],
          });
        }
      });
      getConfigIncomingOutgoingRoute('', ({ success, data }) => {
        if (success) {
          let incomingOutgoingRouteOption = [];
          if (data && data.configIncomingOutgoingRouteList && data.configIncomingOutgoingRouteList.length) {
            incomingOutgoingRouteOption = data.configIncomingOutgoingRouteList.map(val => {
              return { label: val.value, value: val.value };
            });
          }
          this.setState({
            incomingOutgoingRouteOption:
              incomingOutgoingRouteOption && incomingOutgoingRouteOption.length
                ? sortBy(incomingOutgoingRouteOption, ['label'])
                : [],
          });
        }
      });
    }
  }

  doGetConfigFailureCodesList = value => {
    const { getConfigFailureCodesList } = this.props;
    const { filter } = this.state;
    getConfigFailureCodesList({ platformName: value || filter?.switchName || 'DIDWW' }, ({ success, data }) => {
      if (success) {
        let failureCodesOption = [];
        if (data && data.length) {
          failureCodesOption = data.map(val => {
            return { label: `${val.value}${val.description ? `: ${val.description}` : ''}`, value: val.value };
          });
        }
        this.setState({
          failureCodesOption:
            failureCodesOption && failureCodesOption.length ? sortBy(failureCodesOption, ['label']) : [],
        });
      }
    });
  };

  onSortColumn = (sortCol, sortDir) => {
    this.setState({ sorted: { sortCol, sortDir } }, () => {
      this.doGetListRawNonBroadsoft();
    });
  };

  onPageChange = pageChange => {
    const { page } = this.state;
    if (page === pageChange) return '';
    return this.setState({ page: pageChange }, () => this.doGetListRawNonBroadsoft());
  };

  onSizeChange = size => {
    this.setState({ size, page: 0 }, () => this.doGetListRawNonBroadsoft());
  };

  onHandleSubmitSearch = filter => {
    this.setState({ filter: { ...filter }, page: 0 }, () => {
      this.doGetListRawNonBroadsoft();
    });
  };

  doGetListRawNonBroadsoft = () => {
    const { filter, page, size, sorted } = this.state;
    const newFilter = cloneDeep(filter);
    if (!newFilter.startDate) {
      newFilter.startDate = moment()
        .startOf('month')
        .format('YYYY-MM-DD HH:mm:ss');
    }
    if (!newFilter.endDate) {
      newFilter.endDate = moment()
        .endOf('month')
        .format('YYYY-MM-DD HH:mm:ss');
    }
    if (!newFilter.switchName) {
      newFilter.switchName = 'DIDWW';
    }
    const { getNonBroadSoftRawCdrData, id } = this.props;
    if (id) filter.accountId = id;
    const payload = {
      page: page + 1,
      size,
      filter: newFilter,
      sort:
        !isEmpty(sorted) && sortRawNonBroadsoft[sorted.sortCol]
          ? sortRawNonBroadsoft[sorted.sortCol][sorted.sortDir]
          : null,
    };
    this.setState({ isSearching: true });
    getNonBroadSoftRawCdrData(payload, () => {
      this.setState({ isSearching: false });
    });
  };

  doGetAlllistRawNonBroadsoft = cb => {
    const { filter, sorted } = this.state;
    const newFilter = cloneDeep(filter);
    if (!newFilter.startDate) {
      newFilter.startDate = moment()
        .startOf('month')
        .format('YYYY-MM-DD HH:mm:ss');
    }
    if (!newFilter.endDate) {
      newFilter.endDate = moment()
        .endOf('month')
        .format('YYYY-MM-DD HH:mm:ss');
    }
    if (!newFilter.switchName) {
      newFilter.switchName = 'DIDWW';
    }
    const { getAllNonBroadSoftRawCdrData, id } = this.props;
    if (id) filter.accountId = id;
    const payload = {
      page: 1,
      size: PAGE_SIZE_DOWNLOAD,
      filter: newFilter,
      sort: !isEmpty(sorted) ? sortRawNonBroadsoft[sorted.sortCol][sorted.sortDir] : null,
    };
    getAllNonBroadSoftRawCdrData(payload, () => {
      if (cb) cb();
    });
  };

  onChangeSwitch = () => {
    const { isActivePdf } = this.state;
    this.setState({ isActivePdf: !isActivePdf });
  };

  onExport = () => {
    this.doGetAlllistRawNonBroadsoft(() => {
      const { isActivePdf } = this.state;
      if (isActivePdf) {
        const { listAllRawNonBroadsoft, t } = this.props;
        convertJson2Pdf({
          data: listAllRawNonBroadsoft,
          t,
          title: t('reportPage:sidebar.metaswitch').toLocaleUpperCase(),
          fileName: `${t('reportPage:sidebar.metaswitch')
            .toLocaleLowerCase()
            .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`,
          columnsTable: tableColumnsOutput,
        });
      } else {
        this.buttonRef.current.click();
      }
    });
  };

  sendEmail = ({ subject, emailBody }) => {
    this.doGetAlllistRawNonBroadsoft(() => {
      const { listAllRawNonBroadsoft, t, uploadMultiPartFiles } = this.props;
      const { emails, isActivePdf } = this.state;

      const query = `{"query": "mutation{sendReport(input: ${parseToMutationRequestPostMethod(
        {
          emailAddress: emails.join(', '),
          type: 'GET_NON_BROADSOFT_RAW_CDR_REPORT',
          subject: subject || `Embrix Report ${t('reportPage:sidebar.metaswitch')}`,
          emailBody,
        },
        ['type']
      )})}"}`;
      const formData = new FormData();

      if (!isActivePdf) {
        formData.append(
          'file',
          blobToCSVFile({
            fileName: `${t('reportPage:sidebar.metaswitch')
              .toLocaleLowerCase()
              .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}.csv`,
            data: listAllRawNonBroadsoft,
            t,
            columns: tableColumnsOutput,
          })
        );
      } else {
        const pdfFile = convertJson2Pdf({
          data: listAllRawNonBroadsoft,
          t,
          title: t('reportPage:sidebar.metaswitch').toLocaleUpperCase(),
          fileName: `${t('reportPage:sidebar.metaswitch')
            .toLocaleLowerCase()
            .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`,
          isFile: true,
          columnsTable: tableColumnsOutput,
        });
        formData.append(
          'file',
          blobToFile(
            pdfFile,
            `${t('reportPage:sidebar.metaswitch')
              .toLocaleLowerCase()
              .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`
          )
        );
      }

      formData.append('graphql', query);
      // formData.append('file', blobToFile(pdfFile, 'attachment'));
      uploadMultiPartFiles(
        formData,
        res => {
          if (res && res.success) {
            if (res.success) this.setState({ emails: [] });
          }
        },
        true
      );
    });
  };

  onChangeEmail = tags => {
    let isEmail = true;
    if (tags && tags.length) {
      tags.forEach(email => {
        if (!validateEmail(email)) {
          isEmail = false;
        }
      });
    }
    if (!isEmail) return '';

    return this.setState({ emails: tags });
  };

  doGetOutputTemplateByType = () => {
    const { getOutputTemplateByType, t } = this.props;
    getOutputTemplateByType('RAW_NON_BROADSOFT_REPORT', ({ success, data }) => {
      if (success && data) {
        this.setState({
          exportColumnsSave: configOutputTemplateByType({
            columns: tabelColumnExportRawNonBroadsoft,
            data,
            t,
          }),
          idOutputTemplate: data?.id,
          typeOutputTemplate: data?.type,
        });
      }
    });
  };

  onHandleSaveConfig = columns => {
    const { saveOutputTemplateByType } = this.props;
    const { idOutputTemplate, typeOutputTemplate } = this.state;
    const payload = {
      id: idOutputTemplate,
      type: typeOutputTemplate,
      source: columns.sourceFields.items.map((val, index) => {
        return { name: val.name, index: index + 1 };
      }),
      target: columns.targetFields.items.map((val, index) => {
        return { name: val.name, index: index + 1 };
      }),
    };

    saveOutputTemplateByType(payload, ({ success }) => {
      if (success) {
        this.doGetOutputTemplateByType();
        this.setState({ exportColumnsSave: columns, isOpenModalExportConfig: false });
      }
    });
  };

  onToggleModalExportConfig = () => {
    const { isOpenModalExportConfig } = this.state;
    this.setState({ isOpenModalExportConfig: !isOpenModalExportConfig });
  };

  render() {
    const {
      isSearching,
      isActivePdf,
      sorted,
      page,
      size,
      totalCount,
      listRawNonBroadsoft,
      emails,
      exportColumnsSave,
      isOpenModalExportConfig,
      failureCodesOption,
      iddOption,
      idoOption,
      incomingOutgoingRouteOption,
      sreservedOption,
      configOrganizationOption,
    } = this.state;
    const {
      listAllRawNonBroadsoft,
      t,
      permissions: { modeGetNonBroadsoftMapReport, modeDownloadReport, modeGetMailReport },
    } = this.props;
    if (!modeGetNonBroadsoftMapReport) return '';
    const exportColumns = exportColumnsSave || {};
    tableColumnsOutput = exportColumns?.targetFields?.items || [];
    return (
      <div className="col-md-12">
        <PageTitle
          linkTo={RouteNames.report.path}
          titleBtn="back"
          items={[
            { name: t('label.report'), url: RouteNames.report.path },
            { name: t('reportPage:sidebar.metaswitch') },
          ]}
        />
        <br />
        <div className="card card-statistics mb-30">
          <TitleFrom title={t('reportPage:sidebar.metaswitch')} />
          <div className="col-md-12 mb-30">
            <div className="card-body">
              <div className="pl-2">
                <RawNonBroadsoftSearchForm
                  onSubmit={this.onHandleSubmitSearch}
                  isMultipleOptionInject
                  optionsInject={{
                    incomingRoute: incomingOutgoingRouteOption,
                    outgoingRoute: incomingOutgoingRouteOption,
                    failureCode: failureCodesOption,
                    idd: iddOption,
                    sreserved: sreservedOption,
                    clientName: configOrganizationOption,
                  }}
                  handleInputChange={({ name, value }) => {
                    if (name === 'switchName') {
                      this.doGetConfigFailureCodesList(value);
                    }
                  }}
                  onHandleClearInput={() => this.doGetConfigFailureCodesList('DIDWW')}
                />
              </div>
              <div>
                <div className="mt-3 col-md-12 row mb-4 pt-3 pb-3">
                  <button
                    type="submit"
                    onClick={this.onToggleModalExportConfig}
                    className="button x-small mr-2 btn-config"
                  >
                    {/* {t('label.outputConfig')} */}
                    <i className="ti-list" />
                  </button>
                  {!!modeDownloadReport && (
                    <div className="ml-auto mt-2 mb-auto mr-3">
                      <SwitchExport
                        onChange={this.onChangeSwitch}
                        wrapperClass={isActivePdf ? 'switch-active' : 'switch-non-active'}
                        title={t('label.excel')}
                        checked={isActivePdf}
                        rightTitle={t('label.pdf')}
                      />
                    </div>
                  )}
                  {!!modeDownloadReport && (
                    <>
                      <ButtonExport onExport={this.onExport} />
                      <ExcelExport
                        element={<button type="button" className="display-none" ref={this.buttonRef} />}
                        nameSheet={t('reportPage:sidebar.metaswitch').toLocaleUpperCase()}
                        multiDataSet={convertJson2Sheet({
                          data: listAllRawNonBroadsoft,
                          t,
                          title: t('reportPage:sidebar.metaswitch').toLocaleUpperCase(),
                          columnsTable: tableColumnsOutput,
                        })}
                        fileName={`${t('reportPage:sidebar.metaswitch')
                          .toLocaleLowerCase()
                          .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`}
                      />
                    </>
                  )}
                  {modeGetMailReport !== 0 && (
                    <EmailGroup
                      emails={emails}
                      onChangeEmail={this.onChangeEmail}
                      sendEmail={this.sendEmail}
                      data={listRawNonBroadsoft}
                    />
                  )}
                </div>
                <DataTable
                  columns={tableColumnsOutput}
                  data={listRawNonBroadsoft && listRawNonBroadsoft.length ? listRawNonBroadsoft : []}
                  onSort={this.onSortColumn}
                  sorted={sorted}
                  isLoading={isSearching}
                  isFixedHeaderTable
                />
              </div>
            </div>
          </div>
        </div>
        <div className="mb-30">
          <TablePagination
            pageNumber={page}
            pageSize={size}
            totalCount={totalCount}
            onPageChange={this.onPageChange}
            onSizeChange={this.onSizeChange}
          />
        </div>
        <ModalWithItem
          onToggle={this.onToggleModalExportConfig}
          isOpen={isOpenModalExportConfig}
          wrapperClass="modal-config"
        >
          <div className="col-md-12 d-flex">
            <div className="column-config" onClick={this.onToggleModalExportConfig} />
            <div className="body-config">
              <DragDropConfigExportTemplate
                onHandleSave={this.onHandleSaveConfig}
                exportColumns={exportColumns}
                onToggle={this.onToggleModalExportConfig}
              />
            </div>
          </div>
        </ModalWithItem>
      </div>
    );
  }
}

RawNonBroadsoft.propTypes = {
  getNonBroadSoftRawCdrData: PropTypes.func,
  getAllNonBroadSoftRawCdrData: PropTypes.func,
  listAllRawNonBroadsoft: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.any), PropTypes.objectOf(PropTypes.any)]),
};

RawNonBroadsoft.defaultProps = {
  getNonBroadSoftRawCdrData: () => {},
  getAllNonBroadSoftRawCdrData: () => {},
  listAllRawNonBroadsoft: [],
};

const mapStateToProps = createStructuredSelector({
  listRawNonBroadsoft: makeGetListRawNonBroadsoft() || [],
  listAllRawNonBroadsoft: makeGetListAllRawNonBroadsoft() || [],
});
export default withTranslation('common')(
  connect(mapStateToProps, {
    getNonBroadSoftRawCdrData,
    getAllNonBroadSoftRawCdrData,
    uploadMultiPartFiles,
    saveOutputTemplateByType,
    getOutputTemplateByType,
    onResetDefaultData,
    getConfigFailureCodesList,
    getConfigIdd,
    getConfigIdo,
    getConfigIncomingOutgoingRoute,
    getConfigSreserved,
    getConfigOrganization,
  })(RawNonBroadsoft)
);
